import {
  ADD_ROW,
  ADD_ROW_CANCEL,
  ADD_ROW_SAVE,

  EDIT_ROW,
  EDIT_ROW_CANCEL,
  EDIT_ROW_SAVE,

  INIT_TABLE,
  CLEAR_TABLE,

  UPDATE_STORE,
} from './constants';

export default {
  [ADD_ROW](state, payload) {
    if (payload.tableName) {
      state[payload.tableName].add = payload.row;
    }
  },
  [ADD_ROW_CANCEL](state, payload) {
    if (payload.tableName) {
      state[payload.tableName].add = null;
    }
  },
  [ADD_ROW_SAVE](state, payload) {
    if (payload.tableName) {
      state[payload.tableName].add = null;
    }
  },

  [EDIT_ROW](state, payload) {
    if (payload.tableName) {
      state[payload.tableName].edit = payload.row;
    }
  },
  [EDIT_ROW_CANCEL](state, payload) {
    if (payload.tableName) {
      state[payload.tableName].edit = null;
    }
  },
  [EDIT_ROW_SAVE](state, payload) {
    if (payload.tableName) {
      state[payload.tableName].edit = null;
    }
  },

  [INIT_TABLE](state, payload) {
    state[payload] = {};
  },
  [CLEAR_TABLE](state, payload) {
    state[payload] = null;
  },

  [UPDATE_STORE](state, payload) {
    state[payload.tableName][payload.form][payload.id] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/hardware/VuexTable/mutations.js